module.exports = __webpack_public_path__ + "media/images/photo/top/plan/plan4-3f8750a32ffdafaaefc02bc95b1c6af0.jpg";